import { apiClient } from './apiClient';

export interface UploadResponse {
  success: boolean;
  message: string;
  data: {
    filename: string;
    originalName: string;
    size: number;
    mimetype: string;
    url: string;
    processed: boolean;
  };
}

export const uploadService = {
  // Subir una imagen
  async uploadImage(file: File): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('image', file);

    const response = await apiClient.post('/upload', formData);

    return response.data;
  },

  // Subir múltiples imágenes
  async uploadMultipleImages(files: File[]): Promise<UploadResponse> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append('images', file);
    });

    const response = await apiClient.post('/upload/multiple', formData);

    return response.data;
  },

};